import { Col, Row } from 'antd';
import * as React from 'react';
import {
    PhoneOutlined,
    MailOutlined,
    FacebookOutlined,
    MessageOutlined,
    ClockCircleOutlined,
    YoutubeOutlined,
    InstagramOutlined
} from '@ant-design/icons';
import logo from "../assets/icon/logo.png"

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className='bg-white border-t-4 border-blue-600 pt-20 pb-10'>
            <div className='max-w-screen-2xl mx-auto px-6 lg:px-10'>
                <Row gutter={[40, 40]}>
                    <Col xs={24} lg={8} xl={7}>
                        <div className='footer-brand mb-8'>
                            <a href="/" className="flex items-center mb-6">
                                <img src={logo} className="mr-3 h-10" alt="Logo" />
                                <span className="self-center text-2xl font-bold whitespace-nowrap text-blue-900">Cuahangykhoa.com</span>
                            </a>
                            <p className='text-gray-700 leading-relaxed max-w-sm mb-6 font-medium'>
                                Hệ thống cửa hàng cung cấp thiết bị y tế chính hãng, uy tín hàng đầu. Cam kết chất lượng và dịch vụ tận tâm cho sức khỏe cộng đồng.
                            </p>
                            <div className='flex space-x-4'>
                                <a href='https://www.facebook.com/cuahangykhoacom' target='_blank' rel='noreferrer' className='w-10 h-10 rounded-full bg-blue-600 text-white flex items-center justify-center hover:bg-blue-700 transition-all duration-300 hover:-translate-y-1 shadow-md'>
                                    <FacebookOutlined className='text-xl' />
                                </a>
                                <a href='#' className='w-10 h-10 rounded-full bg-red-600 text-white flex items-center justify-center hover:bg-red-700 transition-all duration-300 hover:-translate-y-1 shadow-md'>
                                    <YoutubeOutlined className='text-xl' />
                                </a>
                                <a href='#' className='w-10 h-10 rounded-full bg-pink-600 text-white flex items-center justify-center hover:bg-pink-700 transition-all duration-300 hover:-translate-y-1 shadow-md'>
                                    <InstagramOutlined className='text-xl' />
                                </a>
                                <a href='https://zalo.me/0382747847' target='_blank' rel='noreferrer' className='w-10 h-10 rounded-full bg-blue-400 text-white flex items-center justify-center hover:bg-blue-500 transition-all duration-300 hover:-translate-y-1 shadow-md'>
                                    <MessageOutlined className='text-xl' />
                                </a>
                            </div>
                        </div>
                    </Col>

                    <Col xs={24} sm={12} lg={5} xl={4}>
                        <div className='footer-column'>
                            <h4 className='text-lg font-bold text-gray-900 mb-8 border-b-2 border-blue-600 pb-2 inline-block'>
                                Hỗ trợ khách hàng
                            </h4>
                            <ul className='space-y-4'>
                                <li>
                                    <a href='tel:0847799799' className='flex items-center text-gray-800 hover:text-blue-600 transition-colors duration-200 font-semibold'>
                                        <PhoneOutlined className='mr-3 text-blue-600' />
                                        <span>0847 799 799</span>
                                    </a>
                                </li>
                                <li>
                                    <a href='mailto:hotro@cuahangykhoa.com' className='flex items-center text-gray-800 hover:text-blue-600 transition-colors duration-200 font-semibold'>
                                        <MailOutlined className='mr-3 text-blue-600' />
                                        <span>hotro@cuahangykhoa.com</span>
                                    </a>
                                </li>
                                <li>
                                    <div className='flex items-center text-gray-800 font-semibold'>
                                        <ClockCircleOutlined className='mr-3 text-blue-600' />
                                        <span>8:00 - 18:00 (T2 - CN)</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </Col>

                    <Col xs={24} sm={12} lg={5} xl={4}>
                        <div className='footer-column'>
                            <h4 className='text-lg font-bold text-gray-900 mb-8 border-b-2 border-green-600 pb-2 inline-block'>
                                Hợp tác
                            </h4>
                            <ul className='space-y-4'>
                                <li>
                                    <a href='tel:0847799799' className='text-gray-800 hover:text-blue-600 transition-colors duration-200 font-semibold'>
                                        Liên hệ hợp tác
                                    </a>
                                </li>
                                <li>
                                    <a href='#' className='text-gray-800 hover:text-blue-600 transition-colors duration-200 font-semibold'>
                                        Tuyển dụng
                                    </a>
                                </li>
                                <li>
                                    <a href='#' className='text-gray-800 hover:text-blue-600 transition-colors duration-200 font-semibold'>
                                        Chính sách cộng tác viên
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </Col>

                    <Col xs={24} sm={12} lg={6} xl={4}>
                        <div className='footer-column'>
                            <h4 className='text-lg font-bold text-gray-900 mb-8 border-b-2 border-yellow-500 pb-2 inline-block'>
                                Chính sách
                            </h4>
                            <ul className='space-y-4'>
                                <li>
                                    <a href='https://docsachxyz.com/cauhoi1' className='text-gray-800 hover:text-blue-600 transition-colors duration-200 font-semibold'>
                                        Hướng dẫn mua hàng
                                    </a>
                                </li>
                                <li>
                                    <a href='https://docsachxyz.com/cauhoi2' className='text-gray-800 hover:text-blue-600 transition-colors duration-200 font-semibold'>
                                        Chính sách đổi trả
                                    </a>
                                </li>
                                <li>
                                    <a href='https://docsachxyz.com/cauhoi3' className='text-gray-800 hover:text-blue-600 transition-colors duration-200 font-semibold'>
                                        Chính sách bảo mật
                                    </a>
                                </li>
                                <li>
                                    <a href='#' className='text-red-600 hover:text-red-700 transition-colors duration-200 font-bold'>
                                        Khiếu nại: 0847 799 799
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </Col>

                    <Col xs={24} sm={12} lg={0} xl={5} className="hidden xl:block">
                        <div className='footer-column'>
                            <h4 className='text-lg font-bold text-gray-900 mb-8 border-b-2 border-red-600 pb-2 inline-block'>
                                Đăng ký nhận tin
                            </h4>
                            <p className='text-sm text-gray-800 mb-4 font-semibold'>Nhận ngay các ưu đãi hấp dẫn từ chúng tôi.</p>
                            <div className='flex'>
                                <input type='text' placeholder='Email của bạn' className='bg-gray-100 border-2 border-gray-200 px-4 py-2 rounded-l-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 w-full text-gray-900 font-medium' />
                                <button className='bg-blue-600 text-white px-5 py-2 rounded-r-lg hover:bg-blue-700 transition-colors font-bold'>Gửi</button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </footer>
    );
}